import {Extent} from "ol/extent";
import {L} from "../../lt-ng/landcare-toolkit";
import Item = L.tree.Item;
import {LTServices} from "../../lt-ng/lt-services";
import IMapService = LTServices.IMapService;
import {IBaseGeoAppScope} from "../../controllers/IBaseGeoAppScope";
import {ISharedFeatureControlState} from "../ISharedFeatureState";

export type AppPane = "Search" | "Layers" | "Pins" | "Metadata" | "Overview" | "Legend" | "SoilSummary" | "Properties" | "Features";

export type ContainingPane = 'paneLeftCollapsed' | 'paneBottomCollapse' | 'paneRightCollapse';

export interface LandcareToolkitConfiguration {
	// TODO: define properties
}

export interface IAppConfig {
    pointQueryPane: string;
	printModuleApplication(): string;
	getContainingPane(pane: AppPane): ContainingPane;
	isSingleClickAddPin(): boolean;
	includeItemsByDefault(): boolean;
	getApplication(): string;
	deselectPinOnPaneClose: boolean;
	expandGroupsByDefault(): boolean;
	multiplePinsInRHP(): boolean;
	// [846720, 4426240, 2365440, 6496000]
	layerExtent: Extent; // a default value for map layers. See BaseLayer.extent - anything outside the extent won't be rendered by the layers.
    /**
     * Carry out application specific actions on initiation of the GeoApp controller
     * @param {IBaseGeoAppScope} $scope
     * @param mapService
     */
	initGeoApp($scope: IBaseGeoAppScope, mapService?: IMapService ): void;
	tourURL(): string;

	getLayersForPointQuery(treeData: Item|Item[], reportingLayers?: Item[]): Item[];
	getLandcareToolkitConfiguration(): any | LandcareToolkitConfiguration;
	getLayersForPointQuery(treeDate: Item|Item[]): Item[];
    isSingleClickActive(sharedState: ISharedFeatureControlState): boolean;
}

export abstract class BaseAppConfig implements Partial<IAppConfig> {
	getLandcareToolkitConfiguration() {
		const key = 'LTConfiguration';
		const config = key in window ? window[key] as any | LandcareToolkitConfiguration : {};
		return config;
	}
}
